import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import Datepicker from 'react-datepicker';
import FloatInput from '../../common/floatInput';
import ArbiterApi from '../../../api/ArbiterApi';
import { permissioned } from '../../common/permissionedHoc';
import Constants from '../../../configurations/constants';
import Messages from '../../../configurations/messages';


class DisputesFilter extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            logCode: '',
            category: null,
            region: null,
            status: null,
            regions : [],
            createdFromDate: null,
            createdToDate: null,
            expiresFromDate: null,
            expiresToDate: null,
            dateFilterChecked: false,
            searchButtonDisabled: true
        };
        this.onDisputeCategoryChange = this.onDisputeCategoryChange.bind(this);
        this.onDisputeRegionChange = this.onDisputeRegionChange.bind(this);
        this.onDisputeStatusChange = this.onDisputeStatusChange.bind(this);
        this.onCreatedFromDateChange = this.onCreatedFromDateChange.bind(this);
        this.onExpiresFromDateChange = this.onExpiresFromDateChange.bind(this);
        this.onCreatedToDateChange = this.onCreatedToDateChange.bind(this);
        this.onExpiresToDateChange = this.onExpiresToDateChange.bind(this);
        this.onEnableDateFilterChange = this.onEnableDateFilterChange.bind(this);
        this.onSearchHandler = this.onSearchHandler.bind(this);
        this.onTextInputChange =  this.onTextInputChange.bind(this);
    }


    componentDidMount()
    {
        ArbiterApi.getDisputeRegions()
        .then(response =>{
            let regions = response.data.content.map(region =>{ return {value : region.name, label : region.name }});
            this.setState({regions : regions});
        })
        .catch(error => {
            Toaster.error(`${error.status} - ${Messages.ERROR_DISPUTE_REGION}`);
            console.log(error);
        });
    }

    
    onTextInputChange(event) {
        let stateUpdate = {};
        stateUpdate[event.target.id] = event.target.value;
        this.setState(stateUpdate);
    }

    onCreatedFromDateChange(date) {
        this.setState({ createdFromDate: date });

    }
    onCreatedToDateChange(date) {
        this.setState({ createdToDate: date });

    }
    onExpiresFromDateChange(date) {
        this.setState({ expiresFromDate: date });

    }
    onExpiresToDateChange(date) {
        this.setState({ expiresToDate: date });

    }
    onEnableDateFilterChange(event)
    {
         this.setState({ dateFilterChecked: event.target.checked });
    }
    onSearchHandler() {
        //TODO: validate control values AND BUILD PARAMS

        //Build Params
        let params = {};
        if(this.state.logCode)
            params.logCode = this.state.logCode;
        if(this.state.region)
            params.region = this.state.region;
        if(this.state.status)
            params.status = this.state.status;
        if(this.state.category)
            params.category = this.state.category;
        if(this.state.region)
            params.region = this.state.region;
        if(this.state.createdFromDate)
            params.createdStartDate = this.state.createdFromDate.format(`${Constants.DATE_FORMAT} 00:00:00`);
        if(this.state.createdToDate)
            params.createdEndDate = this.state.createdToDate.format(`${Constants.DATE_FORMAT} 00:00:00`);
        if(this.state.expiresFromDate)
            params.expiryStartDate = this.state.expiresFromDate.format(`${Constants.DATE_FORMAT} 00:00:00`);
        if(this.state.expiresToDate)
            params.expiryEndDate = this.state.expiresToDate.format(`${Constants.DATE_FORMAT} 00:00:00`);
        

        this.props.onSearchHandler && this.props.onSearchHandler(params, true);
    }
    onDisputeCategoryChange(event) {
        this.setState({
            category: event ? event.value :  ''

        });
    }
    onDisputeRegionChange(event) {
        this.setState({
            region: event ? event.value :  ''
        });
    }
    onDisputeStatusChange(event) {
        this.setState({
            status: event ? event.value :  ''
           
        });
    }

    render() {

        return (
            <form onSubmit={(e) => { this.onSearchHandler(); e.preventDefault(); return false; }}>
                <div>
                    <div className="row filters">
                        <div className="col-md-3">
                            <FloatInput
                                id="logCode"
                                value={this.state.logCode}
                                onChange={this.onTextInputChange}
                                placeholder="Log Code" />

                        </div>
                        <div className="col-md-3"  id="categoryColumn">
                            <Select
                                name="category"
                                placeholder="Dispute Category"
                                value={this.state.category}
                                options={
                                    [
                                        { value: Constants.DISPUTE_CATEGORY_CHARGEBACK, label: Constants.DISPUTE_CATEGORY_CHARGEBACK },
                                        { value: Constants.DISPUTE_CATEGORY_REFUND, label: Constants.DISPUTE_CATEGORY_REFUND },
                                        { value: Constants.DISPUTE_CATEGORY_FRAUD, label: Constants.DISPUTE_CATEGORY_FRAUD },
                                        { value: Constants.DISPUTE_CATEGORY_MERCHANT_SETTLEMENT, label: Constants.DISPUTE_CATEGORY_MERCHANT_SETTLEMENT },
                                        { value: Constants.DISPUTE_CATEGORY_GOOD_FAITH, label: Constants.DISPUTE_CATEGORY_GOOD_FAITH}
                                    ]}
                                onChange={this.onDisputeCategoryChange}
                            />
                        </div>
                        <div className=" col-md-2"  id="statusColumn">
                            <Select
                                name="status"
                                placeholder="Dispute Status"
                                value={this.state.status}
                                options={
                                    [
                                        { value: 'CHARGEBACK', label: 'CHARGEBACK' },
                                        { value: 'ACCEPTED', label: 'ACCEPTED' },
                                        { value: 'DECLINED', label: 'DECLINED' },
                                        { value: 'REPRESENTMENT', label: 'REPRESENTMENT' },
                                        { value: 'PRE_ARBITRATION', label: 'PRE_ARBITRATION' },
                                        { value: 'ARBITRATION', label: 'ARBITRATION' },
                                        { value: 'GOOD_FAITH', label: "GOOD_FAITH" },
                                        { value: 'REFUND', label: 'REFUND' },

                                    ]}
                                onChange={this.onDisputeStatusChange}
                            />
                        </div>
                          <div className=" col-md-3"  id="regionColumn">
                            <Select
                                name="region"
                                placeholder="Dispute Region"
                                value={this.state.region}
                                options={this.state.regions}
                                onChange={this.onDisputeRegionChange}
                            />
                        </div>


                        <div className=" col-md-1">
                            <button
                                id="searchButton"
                                className="btn btn-primary"
                                type="submit">
                                Search
                        </button>
                        </div>

                    </div>
                    <div style={{textAlign :  'right'}}>
                        <div className="checkbox">
                            <label>
                                <input type="checkbox" id="advancedCheckBox" onChange={this.onEnableDateFilterChange} />
                                <span className="lbl"
                                    checked={this.state.dateFilterChecked}
                                   >Advanced Options</span>
                            </label>
                        </div>
                    </div>
                    {this.state.dateFilterChecked &&
                        <div className="row filters">
                            <div className="col-md-6">
                                <div>
                                    <label>Created On</label>    
                                </div>
                                <span className="datepicker-container">
                                    <Datepicker
                                        onChange={this.onCreatedFromDateChange}
                                        className="input-control"
                                        id="createdFromDate"
                                        placeholderText="From Date"
                                        disabledKeyboardNavigation
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        maxDate={this.state.createdToDate ?  this.state.createdToDate : null}
                                        dateFormat={Constants.DATE_FORMAT}
                                        selected={this.state.createdFromDate} />
                                </span>
                               <span className="datepicker-container">
                                    <Datepicker
                                        onChange={this.onCreatedToDateChange}
                                        className="input-control"
                                        id="createdToDate"
                                        placeholderText="To Date"
                                        disabledKeyboardNavigation
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.createdFromDate ?  this.state.createdFromDate : null}
                                        dateFormat={Constants.DATE_FORMAT}
                                        selected={this.state.createdToDate} />
                                </span>
                            </div>

                            <div className="col-md-6">
                               <div>
                                    <label>Status Expires On</label>    
                                </div>
                                <span className="datepicker-container">
                                    <Datepicker
                                        onChange={this.onExpiresFromDateChange}
                                        className="input-control"
                                        id="expiresFromDate"
                                        placeholderText="From Date"
                                        disabledKeyboardNavigation
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        maxDate={this.state.expiresToDate ?  this.state.expiresToDate : null}
                                        dateFormat={Constants.DATE_FORMAT}
                                        selected={this.state.expiresFromDate} />
                                </span>
                               <span className="datepicker-container">
                                    <Datepicker
                                        onChange={this.onExpiresToDateChange}
                                        className="input-control"
                                        id="expiresToDate"
                                        placeholderText="To Date"
                                        disabledKeyboardNavigation
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.expiresFromDate ?  this.state.expiresFromDate : null}
                                        dateFormat={Constants.DATE_FORMAT}
                                        selected={this.state.expiresToDate} />
                                </span>
                            </div>
                        </div>
                    }
                </div>
            </form>
        );
    }
}

export default permissioned(DisputesFilter);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/disputesFilter.js